const stockPageOptionalSections = {
  RECOMMENDATIONS: "recommendations",
  DIVIDENDS: "dividends",
  FINANCIAL_SITUATION: "financial_situation",
  STOCK_ANALYSES: "stock_analyses",
  INSIDERS_TRANSACTIONS: "insiders_transactions"
};

export default stockPageOptionalSections;
